import { render, staticRenderFns } from "./SertifikatWorkshop.vue?vue&type=template&id=ee6bcf0e&"
import script from "./SertifikatWorkshop.vue?vue&type=script&lang=js&"
export * from "./SertifikatWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./SertifikatWorkshop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports